<template lang="pug">
  b-list-group.list-group-accent
    b-list-group-item.list-group-item-accent-secondary.bg-light.text-center.font-weight-bold.text-muted.text-uppercase.small {{ $t('language.selection') }}
    b-list-group-item.list-group-item-accent-primary.cursor-pointer(
      @click="setLanguage('en')"
      :class="[$store.getters.language == 'en' ? 'active' : '' ]"
      ).ripple
      div.d-flex.justify-content-between.align-items-center.border-0
        span {{ $t("language.english") }}
        i.flag-icon.flag-icon-us
    b-list-group-item.list-group-item-accent-info.cursor-pointer(
      @click="setLanguage('zh')"
      :class="[$store.getters.language == 'zh' ? 'active' : '' ]"
      ).ripple
      div.d-flex.justify-content-between.align-items-center.border-0
        span {{ $t("language.simplified_chinese") }}
        i.flag-icon.flag-icon-cn
</template>

<script>
import config from "@/config";

export default {
  methods: {
    setLanguage(lang){
      this.$store.dispatch("layout/setLanguage", lang);
    }
  }
}
</script>

<style lang="scss" scoped>
.flag-icon {
  font-size: 20px;
  box-shadow: 0 0 8px white, 0 0 0 white;
}
</style>
